module.exports = require('./SpinnerView');
